module.exports = require('./SpinnerView');
